import { USER_PERMISSIONS } from "../../constants/storageKeys";
import { UserOperationTypes } from "../types/AuthorizationProps";
import { getUserIdentity } from "./authorizationHelper";
import { decryptAES } from "./encryptonHelper";

export const isBankSelectable = () => {
    const userIdentity = getUserIdentity();
    if (userIdentity !== "ADMIN") {
        const permissions: number[] = JSON.parse(
            decryptAES(localStorage.getItem(USER_PERMISSIONS) || "")
        );
        if (!permissions.includes(UserOperationTypes["Banka Seçimi"])) {
            return false;
        }
    }
    return true;
}